import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import './style.scss';

export default function Popup(props) {
	const { onClose, popupState, children } = props;

	return (
		<AnimatePresence>
			{popupState && (
				<div className='popup'>
					<motion.div initial={{ opacity: 0 }} animate={{ opacity: 0.5 }} exit={{ opacity: 0 }} className={classNames({ popup__backdrop: true })} onClick={() => onClose(false)}></motion.div>
					<motion.div initial={{ y: -50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -50, opacity: 0 }} transition={{ duration: 0.3 }} className={classNames({ popup__content: true })}>
						{children}
					</motion.div>
				</div>
			)}
		</AnimatePresence>
	);
}

Popup.propTypes = {
	popupState: PropTypes.bool,
	popupAnimationState: PropTypes.bool,
	onClose: PropTypes.any
};

Popup.defaultProps = {
	popupState: false,
	popupAnimationState: false,
	onClose: ''
};
